/**
 * ArticleLayoutDefault - Standard article reading layout
 * Uses the full article schema for display
 */
import React from 'react';

const ArticleLayoutDefault = ({ children, article = {} }) => {
    return (
        <div className="article-layout article-layout--default">
            <div className="article-layout__body">
                {children}
            </div>
        </div>
    );
};

export default ArticleLayoutDefault;
